// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1pbUZ","inputWrap":"CustomTip_inputWrap__2oRWo"};